import { SelectList } from 'complex-data'
import { SelectListValueType } from 'complex-data/src/data/SelectList'
import selectApi from '../api/select'
import { loadDefaultDictList } from './config'
import ComplexSelect from '@/class/ComplexSelect'
import option from '@/style/option'

export const baseSwitch = new SelectList<SelectListValueType<string>>({
  name: '是否',
  list: [
    {
      value: '0',
      label: '否'
    },
    {
      value: '1',
      label: '是'
    },
  ]
})

export interface ApprovalStatusValueType extends SelectListValueType<string> {
  status: 'ing' | 'fail' | 'success'
}

export const ApprovalStatus = new SelectList<ApprovalStatusValueType>({
  name: '审批状态',
  list: [
    {
      value: '1',
      label: '审批中',
      status: 'ing'
    },
    {
      value: '2',
      label: '通过',
      status: 'success'
    },
    {
      value: '9',
      label: '拒绝',
      status: 'fail'
    }
  ]
})

export interface FlowStatusValueType extends SelectListValueType<string> {
  status: 'normal' | 'refuse' | 'reject' | 'end'
  color?: string
}

export const FlowStatus = new SelectList<FlowStatusValueType>({
  name: '流程状态',
  list: [
    {
      value: '1',
      label: '正常',
      status: 'normal'
    },
    {
      value: '2',
      label: '退回',
      status: 'refuse',
      color: option.color.danger
    },
    {
      value: '3',
      label: '驳回',
      status: 'reject',
      color: option.color.warn
    },
    {
      value: '4',
      label: '委派',
      status: 'normal'
    },
    {
      value: '5',
      label: '转办',
      status: 'normal'
    },
    {
      value: '6',
      label: '终止',
      status: 'end'
    },
    {
      value: '7',
      label: '未操作',
      status: 'normal'
    }
  ]
})

export const areaRegion = new ComplexSelect<SelectListValueType<string>>({
  name: '区域列表',
  list: [],
  getData(this: ComplexSelect<SelectListValueType<string>>) {
    return new Promise((resolve, reject) => {
      selectApi.areaRegion.require().then(res => {
        const list = res.data.data.map(item => {
          return {
            value: item.id,
            label: item.areaName
          }
        })
        resolve({ status: 'success', list: list })
      }).catch(err => {
        reject(err)
      })
    })
  }
})

export const operationPersonnel = new ComplexSelect<SelectListValueType<string>>({
  name: '运营人员',
  list: [],
  getData(this: ComplexSelect<SelectListValueType<string>>) {
    return loadDefaultDictList(selectApi.operationPersonnel)
  }
})

export const loadAllDict = function() {
  return Promise.allSettled([areaRegion.$loadData(), operationPersonnel.$loadData()])
}
